import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import OfferBookingApprovalService from '../services/offerBookingApproval.service'

const useOfferBookingApproval = () => {
  const service = new OfferBookingApprovalService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useInviteBookingUser = useAction({
    mutationFn: service.inviteBookingUser,
    queryKey: queryKey,
    message: 'Successfully invited user to booking approval',
  })

  const useReplyBookingInvitation = useAction({
    mutationFn: service.replyBookingInvitation,
    queryKey: queryKey,
    message: 'Successfully replied to booking invitation',
  })

  const useDeleteBookingInvitedUsers = useAction({
    mutationFn: service.deleteBookingInvitedUsers,
    queryKey: queryKey,
    message: 'Successfully removed booking invited users',
  })

  return {
    useInviteBookingUser,
    useReplyBookingInvitation,
    useDeleteBookingInvitedUsers,
  }
}

export default useOfferBookingApproval
